import { z } from "zod/v4";

import { GaStream } from "../../../../../schemas/google";

export const GaGetPropertyStreamsPathParamSchema = z.object({
  accountId: z.string(),
  propertyId: z.string(),
});

export type GaGetPropertyStreamsPathParamType = z.infer<
  typeof GaGetPropertyStreamsPathParamSchema
>;

export type GaGetPropertyStreamsResponseType = {
  streams: GaStream[];
};
